import React, { useState, useEffect } from "react";
import { Container, Table } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Authorization } from "../../Context/Authorization";
import Preloader from "../../shared/PreLoaders";

const ManageShgMember = () => {
  const [shgMemberData, setShgMemberData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);

    const fetchShgMember = async () => {
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/shgMember`, Config);
        if (response.status !== 200) throw new Error("Error fetching members");
        const data = response.data.shgMembers;
        setShgMemberData(Array.isArray(data) ? data : [data]);
      } catch (error) {
        console.error("Error fetching members", error);
      }
      setLoading(false);
    };

    fetchShgMember();
  }, []);

  const deleteShgMembers = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this SHG Members?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      const Config = Authorization();
      const response = await axios.delete(`${Api}/api/shgMember/${id}`, Config);
      if (response.status !== 200) throw new Error("Error deleting member");
      setShgMemberData(shgMemberData.filter((state) => state._id !== id));
    } catch (error) {
      console.error("Error deleting member", error);
    }
  };

  const handleEditShgMember = (id) => {
    navigate(`/manage/shg/member/edit/${id}`); // ✅ Ensure full path
  };

  const groupedShgMembers = shgMemberData.reduce((acc, shgMember) => {
    const shgId = shgMember.shg;
    if (!acc[shgId]) {
      acc[shgId] = {
        shg: shgId,
        members: [],
      };
    }
    acc[shgId].members.push(shgMember);
    return acc;
  }, {});

  const shgMemberList = Object.values(groupedShgMembers);

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> SHG Members </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              SHG Members
            </li>
          </ol>
        </nav>
      </div>
      <Container>
        <>
          <div className="card">
            <div className="card-body">
              <div className="row icons-list">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th rowSpan="2">SINO</th>
                        <th rowSpan="2">SHG</th>
                        <th rowSpan="2">Total Members</th>
                        <th colSpan="6">MEMBERS</th>
                      </tr>
                      <tr>
                        <th>Name</th>
                        <th>Details</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shgMemberList.length > 0 ? (
                        shgMemberList.map((shg, index) => (
                          <React.Fragment key={shg.shg}>
                            <tr>
                              <td rowSpan={shg.members.length}>{index + 1}</td>
                              <td rowSpan={shg.members.length}>
                                {shg.members[0]?.shg?.name || "N/A"}
                              </td>
                              <td rowSpan={shg.members.length}>
                                {shg.members.length}
                              </td>
                              <td>{shg.members[0]?.member?.name || "N/A"}</td>
                              <td>
                                {shg.members[0]?.member
                                  ? `Details about ${shg.members[0].member.name}`
                                  : "N/A"}
                              </td>
                              <td
                                style={{
                                  color:
                                    shg.members[0]?.status === "A"
                                      ? "green"
                                      : "red",
                                }}
                              >
                                {shg.members[0]?.status === "A"
                                  ? "Active"
                                  : "Inactive"}
                              </td>
                              <td>
                                {shg.members[0]?.member && (
                                  <>
                                    <i
                                      className="mdi mdi-pen"
                                      style={{
                                        fontSize: "1.5rem",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleEditShgMember(shg.members[0]._id)
                                      }
                                    />
                                    <i
                                      className="mdi mdi-delete"
                                      style={{
                                        fontSize: "1.5rem",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        deleteShgMembers(shg.members[0]._id)
                                      }
                                    />
                                  </>
                                )}
                              </td>
                            </tr>
                            {shg.members.slice(1).map((member) => (
                              <tr key={member._id}>
                                <td>{member?.member?.name || "N/A"}</td>
                                <td>
                                  {member?.member
                                    ? `Details about ${member.member.name}`
                                    : "N/A"}
                                </td>
                                <td
                                  style={{
                                    color:
                                      member?.status === "A" ? "green" : "red",
                                  }}
                                >
                                  {member?.status === "A"
                                    ? "Active"
                                    : "Inactive"}
                                </td>
                                <td>
                                  {member?.member && (
                                    <>
                                      <i
                                        className="mdi mdi-pen"
                                        style={{
                                          fontSize: "1.5rem",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handleEditShgMember(member._id)
                                        }
                                      />
                                      <i
                                        className="mdi mdi-delete"
                                        style={{
                                          fontSize: "1.5rem",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          deleteShgMembers(member._id)
                                        }
                                      />
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7">No members found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      </Container>
    </div>
  );
};

export default ManageShgMember;
